export default __webpack_public_path__ + "static/media/Q13_2_resized.da1fbe0e.jpg";